// Mock data for UNITYPRO HOMES

export const companyInfo = {
  name: "UNITYPRO HOMES",
  tagline: "Developers Pvt. Ltd.",
  slogan: "खुशियों का नया address",
  managingDirector: "Vipin Yadav",
  designation: "Managing Director",
  phones: ["9910579770", "9205196614"],
  whatsapp: "9910579770",
  address: "1st Floor, Anil Singh Complex, Near MCD Toll Kapashera, Delhi",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.123!2d77.062!3d28.514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDMwJzUwLjQiTiA3N8KwMDMnNDMuMiJF!5e0!3m2!1sen!2sin!4v1234567890"
};

export const featuredPlots = [
  {
    id: 1,
    title: "Premium Residential Plot - Sector 19A",
    type: "plot",
    size: "50 Sq. Yds",
    dimensions: "15' x 30'",
    price: "₹25,00,000",
    location: "Sector 19A, Near Delhi-Alwar Road",
    roadWidth: "23' Wide Road",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800&h=600&fit=crop",
    features: ["Corner Plot", "Gated Community", "24/7 Security", "Clear Title"],
    status: "Available"
  },
  {
    id: 2,
    title: "Luxury Plot - Near IMT Highway",
    type: "plot",
    size: "106.6 Sq. Yds",
    dimensions: "32' x 30'",
    price: "₹48,00,000",
    location: "Sector 20, IMT Highway Access",
    roadWidth: "33' Wide Road",
    image: "https://images.unsplash.com/photo-1513584684374-8bab748fbf90?w=800&h=600&fit=crop",
    features: ["Prime Location", "Wide Road", "Near Highway", "Investment Opportunity"],
    status: "Available"
  },
  {
    id: 3,
    title: "Residential Plot - KMP Expressway",
    type: "plot",
    size: "124 Sq. Yds",
    dimensions: "40' x 30'",
    price: "₹55,00,000",
    location: "Near KMP Expressway, Sector 21",
    roadWidth: "33' Wide Road",
    image: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800&h=600&fit=crop",
    features: ["Large Plot", "Excellent Connectivity", "Approved Layout", "Ready to Build"],
    status: "Available"
  },
  {
    id: 4,
    title: "Budget Friendly Plot - Village Parola",
    type: "plot",
    size: "50 Sq. Yds",
    dimensions: "15' x 30'",
    price: "₹22,00,000",
    location: "Village Parola, Sector 20A",
    roadWidth: "22' Wide Road",
    image: "https://images.unsplash.com/photo-1605146769289-440113cc3d00?w=800&h=600&fit=crop",
    features: ["Affordable Price", "Good Location", "Near Main Road", "Clean Documentation"],
    status: "Available"
  }
];

export const featuredHomes = [
  {
    id: 5,
    title: "Luxury 3BHK Villa",
    type: "home",
    size: "1800 Sq. Ft.",
    bedrooms: 3,
    bathrooms: 3,
    price: "₹85,00,000",
    location: "Kapashera, Delhi",
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&h=600&fit=crop",
    features: ["Modular Kitchen", "Car Parking", "Terrace", "Vastu Compliant"],
    status: "Ready to Move"
  },
  {
    id: 6,
    title: "Modern 2BHK Apartment",
    type: "home",
    size: "1200 Sq. Ft.",
    bedrooms: 2,
    bathrooms: 2,
    price: "₹52,00,000",
    location: "Near Dwarka, Delhi",
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&h=600&fit=crop",
    features: ["Gated Society", "Power Backup", "Lift", "Gym & Club"],
    status: "Under Construction"
  },
  {
    id: 7,
    title: "Spacious 4BHK Independent Floor",
    type: "home",
    size: "2400 Sq. Ft.",
    bedrooms: 4,
    bathrooms: 4,
    price: "₹1,20,00,000",
    location: "Uttam Nagar, Delhi",
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&h=600&fit=crop",
    features: ["Separate Entry", "Balconies", "Reserved Parking", "Prime Location"],
    status: "Ready to Move"
  },
  {
    id: 8,
    title: "Affordable 1BHK Flat",
    type: "home",
    size: "600 Sq. Ft.",
    bedrooms: 1,
    bathrooms: 1,
    price: "₹28,00,000",
    location: "Mohan Garden, Delhi",
    image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&h=600&fit=crop",
    features: ["Perfect for First Home", "Metro Connectivity", "Security", "Water Supply"],
    status: "Ready to Move"
  }
];

export const allProperties = [...featuredPlots, ...featuredHomes];

export const services = [
  {
    title: "Residential Plots",
    description: "Premium plots with clear titles, approved layouts, and excellent connectivity to major highways.",
    icon: "MapPin"
  },
  {
    title: "Homes & Villas",
    description: "Ready-to-move and under-construction homes designed for modern living with all amenities.",
    icon: "Home"
  },
  {
    title: "Farmhouses",
    description: "Spacious farmhouse plots perfect for weekend getaways and agricultural investments.",
    icon: "Trees"
  },
  {
    title: "Commercial Shops",
    description: "Prime commercial properties in high-footfall areas for your business ventures.",
    icon: "Store"
  },
  {
    title: "Legal Assistance",
    description: "Complete documentation support and legal guidance for hassle-free property transactions.",
    icon: "FileCheck"
  },
  {
    title: "Property Management",
    description: "End-to-end property management services from registration to possession.",
    icon: "Settings"
  }
];

export const testimonials = [
  {
    name: "Rajesh Kumar",
    location: "Delhi",
    text: "Excellent service! Vipin sir helped me find the perfect plot for my dream home. Highly recommended!",
    rating: 5
  },
  {
    name: "Priya Sharma",
    location: "Gurgaon",
    text: "Very professional team. The entire process was smooth and transparent. Thank you UNITYPRO HOMES!",
    rating: 5
  },
  {
    name: "Amit Verma",
    location: "Noida",
    text: "Best property dealer in Delhi! Clear documentation and genuine prices. Great investment opportunity.",
    rating: 5
  }
];

export const stats = [
  { label: "Properties Sold", value: "500+" },
  { label: "Happy Clients", value: "1000+" },
  { label: "Years Experience", value: "10+" },
  { label: "Projects Completed", value: "50+" }
];